import * as React from 'react';
import { connect } from 'react-redux';
import { StoreState } from '@ui/store/rootReducer';
import { LoadableContent } from '@ui/components';
import { requestsSelectors } from '../';
import * as actions from '../services/actions';
import Request from '../components/Request';

import './Requests.less';

interface StateToProps {
  loading: boolean;
  requests: any[];
}

interface DispatchToProps {
  onLoadRequests: () => void;
  reload: (request: any, collections: any) => void;
}

type Props = StateToProps & DispatchToProps;

class Requests extends React.PureComponent<Props> {
  componentDidMount(): void {
    const { onLoadRequests } = this.props;

    onLoadRequests();
  }

  handleReload = (request: any) => {
    const { reload } = this.props;

    const result = {
      store: request.store.id,
      user: request.user.id,
      id: request.id,
    };
    const collections = request.collections.filter((item: any) => !item.status);

    reload(
      result,
      collections.map((collection: any) => ({
        collection,
      })),
    );
  };

  render(): React.ReactNode {
    const { loading, requests } = this.props;
    return (
      <LoadableContent loading={loading}>
        <div className="requests-page">
          <div className="requests-page__content">
            <div className="requests-page__info">Запросы</div>
            <div>
              {requests.map(request => (
                <Request
                  key={request.id}
                  request={request}
                  reload={this.handleReload}
                />
              ))}
            </div>
          </div>
        </div>
      </LoadableContent>
    );
  }
}

const mapStateToProps = (state: StoreState): StateToProps => ({
  requests: requestsSelectors.getRequests(state),
  loading: requestsSelectors.getLoading(state),
});

const mapDispatchToProps = {
  onLoadRequests: actions.requestsRequested,
  reload: actions.reloadRequested,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Requests);



// WEBPACK FOOTER //
// ./src/scenes/Requests/containers/Requests.tsx